export default {
  Model: {
    ID: 'id',
    TIME_OF_DAY: 'timeOfDay',
    DAY_OF_WEEK: 'dayOfWeek',
    INTERVAL_UNIT: 'intervalUnit',
    INTERVAL_AMOUNT: 'intervalAmount',
    STARTS_AT: 'startsAt',
    DAY_IN_MONTH: 'dayInMonth',
    WEEK_IN_MONTH: 'weekInMonth',
    ONLY_RECUR_ONCE: 'onlyRecurOnce',
    IS_SECTION_RULE: 'isSectionRule',
    SECTION_RULE_ID: 'sectionRuleId',
  },
};
